import React, { useCallback, useEffect, useRef, useState } from "react";
import { Card, Dropdown, Spinner } from "react-bootstrap";
import Dots from "@assets/images/Menu - Mini.svg";
import Edit from "@assets/images/editIcon.svg";
import Private from "@assets/images/private.svg";
import Public from "@assets/images/public.svg";
import Clone from "@assets/images/clone-wheel.svg";

import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Snackbar } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Delete from "@assets/images/delete2.png";
import Primary from "@assets/images/pin.svg";
import Share from "@assets/images/share2.svg";
import Duplicate from "@assets/images/duplicate.svg";

import WheelComponent from "../WheelComponent";
import "./style.css";
import { generateAiWheelAction } from "../../redux/actions/wheels";
import { useDuplicateWheel, useUnlockWheel } from "../../services/mutations";
import { ASSETS, PATH } from "../../utils/config";
import { toPng } from "html-to-image";
import { colors } from "../../utils";
import AccessKeyEnterModal from "../AccessKeyEnterModal";
import { getLoggedInUser } from "../../utils/helpers";

export default function WheelCard({
  mainName,
  item,
  onDeleteWheelPress = () => {},
  wheelType,
  deletingWheelId,
  isPublic = false,
  isPrivate = false,
  onMakePrimaryPress = () => {},
  onMakePublicPrivatePress = () => {},
  isEditable = true,
  handleCloneWheel,
  toggleDropdown,
  isDropDownOpen,
}) {
  const nav = useNavigate();
  const location = useLocation();

  const [open, setOpen] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [snackbarType, setSnackbarType] = useState("info");

  const [isWheelLocked, setisWheelLocked] = useState(item?.is_locked);
  const [openPasswordModal, setopenPasswordModal] = useState(false);

  const authorId = item.user;
  const currentUserId = getLoggedInUser() || null;

  const unlockWheel = useUnlockWheel();
  const [unlockWheelLoading, setunlockWheelLoading] = useState(false);
  const [unlockError, setUnlockError] = useState("");
  const handleUnlock = (password) => {
    const wheelId = item?.id;
    const accessCode = password;
    setunlockWheelLoading(true);

    unlockWheel.mutate(
      { wheelId, accessCode },
      {
        onSuccess: (response) => {
          setunlockWheelLoading(false);
          console.log("Wheel unlocked successfully:", response.data);
          // ISP-9999 (stgport-locked-wheel-goback-origin-discover-filters-content-behind):
          // stamp where we came from so the locked-wheel modal's Go Back can return
          // here instead of always falling back to the viewer's own gallery.
          nav(`/wheel/${wheelId}?anonymous_key=${response.data.data.key}`, {
            state: { from: `${location.pathname}${location.search}` },
          });
        },
        onError: (err) => {
          setunlockWheelLoading(false);
          setUnlockError(
            err.response?.data?.message ||
              "An error occurred while unlocking the wheel."
          );

          console.log(
            "Error unlocking the wheel:",
            err.response?.data?.message
          );
        },
      }
    );
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const getSnackbarStyle = () => {
    switch (snackbarType) {
      case "downloading":
        return { backgroundColor: colors.primaryLight }; // Amber for downloading
      case "success":
        return { backgroundColor: colors.primary }; // Green for success
      case "error":
        return { backgroundColor: "#F44336" }; // Red for error
      default:
        return {};
    }
  };

  const onShareClick = () => {
    const wheelID = item?.id;
    var _shareURL =
      window.location.origin +
      "/wheel/" +
      wheelID +
      "/" +
      mainName?.replace(/\s/g, "");

    navigator.clipboard.writeText(_shareURL);
    setSnackbarType("success");
    setSnackbarMessage("Link Copied!");
    setSnackbarOpen(true);
  };

  const [chartState, setChartState] = useState([]);
  useEffect(() => {
    const wheelData = item && item?.wheel_section[0]?.activity_wheel;

    const wheelUpdatedData = wheelData?.map((obj, index) => ({
      label: "blank",
      value: "1",
      isBlank: false,
      // position: 0,
      ...obj,
    }));

    const wheelUpdatedDataSorted = wheelUpdatedData?.sort(
      (a, b) => a.position - b.position
    );

    setChartState(wheelUpdatedDataSorted);
  }, [item]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const onEditData = () => {
    // nav(`/EditCustomWheel/${item?.id}/null`);
  };

  const onDeletePress = () => {
    onDeleteWheelPress(wheelType, item?.id);
  };

  const onPrimaryPress = () => {
    onMakePrimaryPress(item?.id, item, wheelType);
  };

  const onPublicPrivatePress = () => {
    onMakePublicPrivatePress(item?.id, item, wheelType);
  };

  const { mutate, isLoading, isError, data } = useDuplicateWheel();

  const onDuplicateWheel = () => {
    mutate(item?.id);
  };

  const onCardPress = (e) => {
    if (isWheelLocked && currentUserId?.id !== authorId) {
      console.log({ isWheelLocked, currentUserId, authorId });
      setopenPasswordModal(true);
    } else {
      if (item?.id) {
        // ISP-9999 (stgport-locked-wheel-goback-origin-discover-filters-content-behind):
        // same origin-stamping as the unlock-success handler above.
        nav(`/wheel/${item.id}`, {
          state: { from: `${location.pathname}${location.search}` },
        });
      } else {
        console.error("item ID not available");
      }
    }
  };

  const ref = useRef(null);
  const onButtonClick = useCallback(() => {
    if (ref.current === null) {
      return;
    }
    setIsDownloading(true);
    setSnackbarMessage("Downloading image...");
    setSnackbarType("downloading");
    setSnackbarOpen(true);

    toPng(ref.current, { cacheBust: true })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = `${mainName}-${item.id}.png`;
        link.href = dataUrl;
        link.click();
        setIsDownloading(false);
        setSnackbarMessage("Image successfully downloaded!");
        setSnackbarType("success");
        setSnackbarOpen(true);
      })
      .catch((err) => {
        setIsDownloading(false);
        setSnackbarMessage("Error downloading image.");
        setSnackbarType("error");
        setSnackbarOpen(true);
        console.error(err);
      });
  }, [ref, mainName, item.id]);

  const showIsDeletingLoader = deletingWheelId === item?.id || isLoading;

  return (
    <div>
      <AccessKeyEnterModal
        error={unlockError}
        setError={setUnlockError}
        loading={unlockWheelLoading}
        onSubmit={(password) => {
          handleUnlock(password);
        }}
        handleClose={() => {
          setUnlockError('')
          setunlockWheelLoading(false);
          setopenPasswordModal(false);
        }}
        isOpen={openPasswordModal}
      ></AccessKeyEnterModal>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        ContentProps={{
          style: getSnackbarStyle(),
        }}
        action={
          <>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleSnackbarClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
      />

      <div style={{ position: "relative" }}>
        {showIsDeletingLoader && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "30px",
              zIndex: 999,
            }}
          >
            <Spinner
              style={{ color: "white" }}
              animation="border"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        )}
        <Card
          onClick={onCardPress}
          style={{
            borderRadius: "30px",
            marginBottom: "10px",
            cursor: "pointer",
          }}
        >
          <Card.Body>
            <div
              className="row"
              style={{ borderBottom: "1px solid #E1E1E1", height: "50px" }}
            >
              <div className="col-lg-8">
                <Card.Title
                  style={{
                    fontSize: "13px",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {mainName}
                </Card.Title>
              </div>
              <div className="col-lg-4">
                <div className="row">
                  <div className="col-lg-12" style={{ textAlign: "end" }}>
                    <Dropdown
                      // show={openDropdownId === item.id}
                      show={isDropDownOpen}
                      style={{ padding: 0, margin: 0 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleDropdown(item.id);
                      }}
                    >
                      <Dropdown.Toggle
                        variant="none"
                        style={{ border: 0, margin: 0, padding: 0 }}
                      >
                        <img src={Dots} alt="menu" width={30} height={30} />
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        variant=" shadow"
                        style={{ minWidth: 180 }}
                      >
                        {isEditable ? (
                          <>
                            <Dropdown.Item role={"button"} onClick={onEditData}>
                              <img
                                src={Edit}
                                className="img-fluid"
                                alt="Edit"
                                width="15"
                                height="15"
                              />
                              &nbsp; Edit
                            </Dropdown.Item>
                            {wheelType !== "clones" &&
                            (isPublic || isPrivate) ? (
                              <Dropdown.Item
                                role={"button"}
                                onClick={onPublicPrivatePress}
                              >
                                <img
                                  src={!isPublic ? Public : Private}
                                  className="img-fluid"
                                  alt="Edit"
                                  width="15"
                                  height="15"
                                />
                                &nbsp; Change to {!isPublic ? "Public" : "Private"}
                              </Dropdown.Item>
                            ) : null}

                            {wheelType !== "clones" && (
                              <Dropdown.Item onClick={onPrimaryPress}>
                                <img
                                  src={Primary}
                                  className="img-fluid"
                                  alt="Share"
                                  width="15"
                                  height="15"
                                />
                                &nbsp; Make Primary
                              </Dropdown.Item>
                            )}

                            {wheelType !== "clones" && (
                              <Dropdown.Item onClick={onDuplicateWheel} href="">
                                <img
                                  src={Duplicate}
                                  className="img-fluid"
                                  alt="duplicate"
                                  width="15"
                                  height="15"
                                />
                                &nbsp; Duplicate
                              </Dropdown.Item>
                            )}
                            {wheelType !== "clones" && isPublic ? (
                              <Dropdown.Item
                                role={"button"}
                                onClick={onShareClick}
                              >
                                <img
                                  src={Share}
                                  className="img-fluid"
                                  alt="Edit"
                                  width="15"
                                  height="15"
                                />
                                &nbsp; Share Wheel
                              </Dropdown.Item>
                            ) : null}
                            <Dropdown.Item onClick={onButtonClick} href="">
                              <img
                                src={ASSETS.download}
                                className="img-fluid"
                                alt="Delete"
                                width="15"
                                height="15"
                              />
                              &nbsp; Download as PNG
                            </Dropdown.Item>
                            <Dropdown.Item onClick={onDeletePress} href="">
                              <img
                                src={Delete}
                                className="img-fluid"
                                alt="Delete"
                                width="15"
                                height="15"
                              />
                              &nbsp; Delete
                            </Dropdown.Item>
                          </>
                        ) : (
                          <Dropdown.Item
                            onClick={() => handleCloneWheel(item.id)}
                          >
                            <img
                              src={Clone}
                              className="img-fluid"
                              alt="Share"
                              width="15"
                              height="15"
                            />
                            &nbsp; Make clone
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </div>

            <div
              ref={ref}
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
              }}
            >
              <WheelComponent
                config={{
                  isSmallView: true,
                }}
                userData={{
                  id: Math.random(),
                  url: item?.wheel_image,
                }}
                maxSelectedArcs={0}
                arcThickness={5}
                // setChartData={setChartState}
                chartData={chartState}
                containerDivStyle={{
                  height: "160px",
                  width: "160px",
                }}
              ></WheelComponent>

              {/* <div
                style={{
                  paddingTop: "12px",
                  height: "140px",
                  width: "140px",
                  position: "relative",
                }}
              >
                {data?.wheel_preview === null || data?.wheel_preview === "" ? (
                  <img
                    src={chart}
                    alt="preview"
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "contain",
                    }}
                  />
                ) : (
                  <>
                    <img
                      src={data?.wheel_preview}
                      alt="preview"
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <img
                      className="rounded-circle"
                      alt="innerpreview"
                      src={data?.wheel_image ? data?.wheel_image : null}
                      style={{
                        height: "80px",
                        width: "80px",
                        objectFit: "cover",
                        position: "absolute",
                        alignSelf: "center",
                        left: 30,
                        top: 35.5,
                      }}
                    />
                  </>
                )}
              </div> */}
            </div>
            {/* <span style={{ color:"#123051",padding:"6px",backgroundColor:"#E7F2FF",border:"1px solid transparent",borderRadius:"132px",fontSize:"13px",paddingLeft:"19px",paddingRight:"16px",marginRight:"12px" }}>Tag1</span>
               <span style={{ color:"#123051",padding:"6px",backgroundColor:"#E7F2FF",border:"1px solid transparent",borderRadius:"132px",fontSize:"13px",paddingLeft:"19px",paddingRight:"16px",marginRight:"12px" }}>Tag2</span>
               <span style={{ color:"#123051",padding:"6px",backgroundColor:"#E7F2FF",border:"1px solid transparent",borderRadius:"132px",fontSize:"13px",paddingLeft:"19px",paddingRight:"16px",marginRight:"12px" }}>Tag3</span>
               <span style={{ color:"#123051",padding:"6px",backgroundColor:"#E7F2FF",border:"1px solid transparent",borderRadius:"132px",fontSize:"13px",paddingLeft:"19px",paddingRight:"16px",marginRight:"12px" }}>Tag4</span> */}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
